webpackJsonp([0],{

/***/ "+0wG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/30-m.2ae754d.jpg";

/***/ }),

/***/ "+fdp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/10-s.020a8fa.jpg";

/***/ }),

/***/ "+oTf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/29-m.20fb899.jpg";

/***/ }),

/***/ "/q2J":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/24-l.ed9e4da.jpg";

/***/ }),

/***/ "/q6K":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/03-s.c47a54d.jpg";

/***/ }),

/***/ "0HEY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/sochi-2017-m.8796e4c.jpg";

/***/ }),

/***/ "0Vjx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/26-m.857fae6.jpg";

/***/ }),

/***/ "1+c0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/10-m.748bee8.jpg";

/***/ }),

/***/ "1Cu7":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./01-m.jpg": "OlgI",
	"./02-m.jpg": "MlFu",
	"./03-m.jpg": "aQqe",
	"./04-m.jpg": "EtNK",
	"./05-m.jpg": "psHA",
	"./06-m.jpg": "KQJu",
	"./07-m.jpg": "CVwm",
	"./08-m.jpg": "jGeF",
	"./09-m.jpg": "5QSQ",
	"./10-m.jpg": "1+c0",
	"./11-m.jpg": "Dhrx",
	"./12-m.jpg": "u7iv",
	"./13-m.jpg": "d2v8",
	"./14-m.jpg": "fO3U",
	"./15-m.jpg": "a7Of",
	"./16-m.jpg": "zosO",
	"./17-m.jpg": "muMd",
	"./18-m.jpg": "eOcC",
	"./19-m.jpg": "7z5+",
	"./20-m.jpg": "XBNR",
	"./21-m.jpg": "HdLW",
	"./22-m.jpg": "kew0",
	"./23-m.jpg": "MJW0",
	"./24-m.jpg": "nMmY",
	"./25-m.jpg": "RE5C",
	"./26-m.jpg": "0Vjx",
	"./27-m.jpg": "wP7n",
	"./28-m.jpg": "qHo6",
	"./29-m.jpg": "+oTf",
	"./30-m.jpg": "+0wG",
	"./31-m.jpg": "asa4",
	"./32-m.jpg": "zqXa",
	"./33-m.jpg": "APX7",
	"./34-m.jpg": "flvd",
	"./35-m.jpg": "YyD8",
	"./36-m.jpg": "WoOq",
	"./37-m.jpg": "SgGY",
	"./38-m.jpg": "SAKm"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1Cu7";

/***/ }),

/***/ "1zbC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/12-s.eba91ac.jpg";

/***/ }),

/***/ "2/31":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/13-l.4185d0b.jpg";

/***/ }),

/***/ "34B5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/02-l.3502e0f.jpg";

/***/ }),

/***/ "4R1l":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/16-s.e183b68.jpg";

/***/ }),

/***/ "4ZqJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/kindergarten-m.a660ede.jpg";

/***/ }),

/***/ "5QSQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/09-m.03a5941.jpg";

/***/ }),

/***/ "5bsd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/15-s.63970c5.jpg";

/***/ }),

/***/ "5kNS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/36-l.b8fa2fb.jpg";

/***/ }),

/***/ "6JWZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/37-s.285a774.jpg";

/***/ }),

/***/ "77VX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/02-s.e23b13c.jpg";

/***/ }),

/***/ "7PdY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/young-doctors-m.04ed81e.jpg";

/***/ }),

/***/ "7QxK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/23-s.d82f125.jpg";

/***/ }),

/***/ "7elO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/16-l.a1ea460.jpg";

/***/ }),

/***/ "7rD+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/ambulance-m.72e7496.jpg";

/***/ }),

/***/ "7z5+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/19-m.bd42b87.jpg";

/***/ }),

/***/ "8S2b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/06-s.74ceaff.jpg";

/***/ }),

/***/ "8rCB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/34-l.6ca3cea.jpg";

/***/ }),

/***/ "APX7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/33-m.586653d.jpg";

/***/ }),

/***/ "Ahn9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/road-l.5574992.jpg";

/***/ }),

/***/ "BUc/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bk9O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CVwm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/07-m.0157749.jpg";

/***/ }),

/***/ "Cbia":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D37o":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/01-s.029cd0d.jpg";

/***/ }),

/***/ "Dhrx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/11-m.00e0ae1.jpg";

/***/ }),

/***/ "Dl04":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/08-s.20af613.jpg";

/***/ }),

/***/ "EtNK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/04-m.bb80330.jpg";

/***/ }),

/***/ "FBBE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FCp/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/06-l.034d605.jpg";

/***/ }),

/***/ "G38D":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/09-l.c562a79.jpg";

/***/ }),

/***/ "H4T9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/19-l.e60bea3.jpg";

/***/ }),

/***/ "HV7/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/putin-440.31d55f1.jpg";

/***/ }),

/***/ "HdLW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/21-m.a0d5959.jpg";

/***/ }),

/***/ "HnSn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/11-l.f62c6a1.jpg";

/***/ }),

/***/ "HrYy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/23-l.56d993f.jpg";

/***/ }),

/***/ "Hufu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/27-s.bc7b287.jpg";

/***/ }),

/***/ "Ifd5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/03-l.659139a.jpg";

/***/ }),

/***/ "Iw74":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/37-l.6e66c83.jpg";

/***/ }),

/***/ "KQJu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/06-m.7e30ffb.jpg";

/***/ }),

/***/ "Ke2r":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/05-l.51301ea.jpg";

/***/ }),

/***/ "MJW0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/23-m.4b4eda2.jpg";

/***/ }),

/***/ "MXh8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/26-l.bba4a71.jpg";

/***/ }),

/***/ "Mk9A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MlFu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/02-m.9b0d1e7.jpg";

/***/ }),

/***/ "MqRX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/19-s.9c19f50.jpg";

/***/ }),

/***/ "N10u":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/08-l.46cac7b.jpg";

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-countup-v2/dist/js/app.js
var app = __webpack_require__("JQm4");
var app_default = /*#__PURE__*/__webpack_require__.n(app);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CounterUp.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var CounterUp = ({
  name: 'CounerUp',
  props: ['start', 'end', 'duration', 'postfix', 'decimals'],
  components: {
    ICountUp: app_default.a
  },
  data: function data() {
    return {
      options: {
        useEasing: true,
        useGrouping: true,
        separator: ' ',
        decimal: ',',
        prefix: '',
        suffix: ''
      }
    };
  },

  methods: {
    callback: function callback(ins) {
      this.$emit('count-completed');
      // ins.update(ins.endVal + 100)
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43067b64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CounterUp.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"bem",rawName:"v-bem",value:(_vm.body),expression:"body"}]},[_c('i-count-up',{attrs:{"start":_vm.start,"end":_vm.end,"decimals":_vm.decimals,"duration":_vm.duration,"options":_vm.options,"callback":_vm.callback}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.postfix)}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_CounterUp = (esExports);
// CONCATENATED MODULE: ./src/components/CounterUp.vue
function injectStyle (ssrContext) {
  __webpack_require__("Cbia")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  CounterUp,
  components_CounterUp,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_CounterUp = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-yandex-maps/vue-yandex-maps.js
var vue_yandex_maps = __webpack_require__("Hlu6");
var vue_yandex_maps_default = /*#__PURE__*/__webpack_require__.n(vue_yandex_maps);

// CONCATENATED MODULE: ./src/components/objects.js
/* harmony default export */ var objects = ([{ 'id': '1', 'object': 'Строительство пристройки блока лучевой терапии радиологического отделения Брянского областного онкологического диспансера (86 процедур/сутки)', 'branch': 'Здравоохранение', 'address': '241033, г. Брянск, пр-т Станке Димитрова, 96', 'latitude': '53.2282985712013', 'longitude': '34.31553600000001', 'year': '2012 год', 'finance': '375,8 млн рублей', 'federalBudget': '287,1 млн рублей' }, { 'id': '2', 'object': 'Строительство детского сада на 45 мест', 'branch': 'Детские сады', 'address': 'Навлинский район, н.п.Синезерки, ул. Школьная, 1', 'latitude': '53.02743807134909', 'longitude': '34.43448200000001', 'year': '2013 год', 'finance': '22,9 млн рублей', 'federalBudget': '12,1 млн рублей' }, { 'id': '3', 'object': 'Строительство онкогематологического центра ГУЗ «Брянская областная детская больница» (9 122,6 кв. м)', 'branch': 'Здравоохранение', 'address': 'Брянск, пр-т Станке-Димитрова, 100 ', 'latitude': '53.22577007122376', 'longitude': '34.31743150000001', 'year': '2013 год', 'finance': '628,5 млн рублей', 'federalBudget': '159,3 млн рублей' }, { 'id': '4', 'object': 'Строительство детского сада на 140 мест', 'branch': 'Детские сады', 'address': 'Выгоничский район, п. Выгоничи, ул. Майская, 2', 'latitude': '53.1074705712952', 'longitude': '34.0689485', 'year': '2013 год', 'finance': '125,3 млн рублей', 'federalBudget': '77,0 млн рублей' }, { 'id': '5', 'object': 'Реконструкция муниципального бюджетного дошкольного образовательного учреждения детский сад №1 на 130 мест', 'branch': 'Детские сады', 'address': 'г. Новозыбков, Советская площадь, 64', 'latitude': '52.547961571697634', 'longitude': '31.920609500000005', 'year': '2014 год', 'finance': '66,2 млн рублей', 'federalBudget': '49,4 млн рублей' }, { 'id': '6', 'object': 'Строительство родильного дома на 98 коек', 'branch': 'Здравоохранение', 'address': '243146, Брянская область, г. Клинцы, ул. Ворошилова, 31а', 'latitude': '52.76300837906604', 'longitude': '32.265366433204576', 'year': '2014 год', 'finance': '831,2 млн рублей', 'federalBudget': '420,9 млн рублей' }, { 'id': '7', 'object': 'Строительство МБОУ СОШ №5 (дошкольная группа) (182 уч/мест)', 'branch': 'Детские сады', 'address': 'г. Сельцо, ул. Школьная, 25', 'latitude': '53.39358007107635', 'longitude': '34.02298149999994', 'year': '2014 год', 'finance': '83,8 млн рублей', 'federalBudget': '20,8 млн рублей' }, { 'id': '8', 'object': 'Строительство школы на 60 мест и детского сада на 10 мест', 'branch': 'Образование', 'address': 'Суземский район, с. Молодежная, 15 ', 'latitude': '52.19630607196592', 'longitude': '34.085872499999994', 'year': '2014 год', 'finance': '101,6 млн рублей', 'federalBudget': '49,8 млн рублей' }, { 'id': '9', 'object': 'Строительство МАУ «Физкультурно-оздоровительный комплекс «Вымпел» с катком на 300 мест', 'branch': 'Спорт', 'address': '242220, Брянская обл., г. Трубчевск, ул. Володарского, 3г', 'latitude': '52.59144857169478', 'longitude': '33.75505899999997', 'year': '2014 год', 'finance': '205,7 млн рублей', 'federalBudget': '150,0 млн рублей' }, { 'id': '10', 'object': 'Строительство МБДОУ д/с «Сказка» на 150 мест', 'branch': 'Детские сады', 'address': 'Клетнянский район, п. Клетня, ул. Декабристов, 5', 'latitude': '53.386373571086786', 'longitude': '33.21590850000001', 'year': '2014 год', 'finance': '100,7 млн рублей', 'federalBudget': '63,5 млн рублей' }, { 'id': '11', 'object': 'Строительство пристройки к зданию МБДОУ «Гордеевский детский сад «Теремок» на 55 мест', 'branch': 'Детские сады', 'address': 'Гордеевский район, с. Гордеевка, ул. Кирова, 1В', 'latitude': '52.960288071407064', 'longitude': '31.96823849999999', 'year': '2014 год', 'finance': '30,5 млн рублей', 'federalBudget': '26,7 млн рублей' }, { 'id': '12', 'object': 'Строительство очистных сооружений (910 м3/сут.)', 'branch': 'Инфраструктура', 'address': 'Комаричский район, п. Комаричи', 'latitude': '52.45823862321163', 'longitude': '34.81300988329791', 'year': '2014 год', 'finance': '79,6 млн рублей   ', 'federalBudget': '58,5 млн рублей' }, { 'id': '13', 'object': 'Реконструкция детского сада под ФАП', 'branch': 'Здравоохранение', 'address': '242466, Брянская обл., Севский р-н, с. Пушкино, ул. Понизовка, д. 4. ', 'latitude': '52.15750907198025', 'longitude': '34.342252', 'year': '2014 год', 'finance': '1,6 млн рублей', 'federalBudget': '0,5 млн рублей' }, { 'id': '14', 'object': 'Строительство детского сада на 150 мест', 'branch': 'Детские сады', 'address': 'г. Севск, ул. Советская, 145', 'latitude': '52.1388470719893', 'longitude': '34.492126999999904', 'year': '2014 год', 'finance': '130,1 млн рублей', 'federalBudget': '97,6 млн рублей' }, { 'id': '15', 'object': 'Строительство МАДОУ детский сад «Дружба» на 155 мест', 'branch': 'Детские сады', 'address': 'микрорайон «Дружба» , с. Глинищево, проезд Свободы, 1', 'latitude': '53.31235107115708', 'longitude': '34.05865400000001', 'year': '2014 год', 'finance': '130,1 млн рублей', 'federalBudget': '97,6 млн рублей' }, { 'id': '16', 'object': 'Строительство МБДОУ детский сад №22 «Лесная сказка» на 115 мест', 'branch': 'Детские сады', 'address': '241524 Брянская область, Брянский район, п. Мичуринский, ул. Андрея Рублева, 7', 'latitude': '53.28223120271881', 'longitude': '34.28219061772157', 'year': '2015 год', 'finance': '119,0 млн рублей', 'federalBudget': '60,0 млн рублей' }, { 'id': '17', 'object': 'Строительство теннисного центра (24 чел/смену)', 'branch': 'Спорт', 'address': 'г. Брянск,  ул. Ульянова, 41а', 'latitude': '53.311329798115395', 'longitude': '34.314897502654944', 'year': '2014 год', 'finance': '177,0 млн рублей', 'federalBudget': '80,0 млн рублей' }, { 'id': '18', 'object': 'Строительство МБДОУ детский сад №5 «Ладушки» на 95 мест', 'branch': 'Детские сады', 'address': 'г. Сельцо, улица Брянская, 2а ', 'latitude': '53.36318757108516', 'longitude': '34.09282549999993', 'year': '2015 год', 'finance': '60,4 млн рублей', 'federalBudget': '25,1 млн рублей' }, { 'id': '19', 'object': 'Строительство МБДОУ детский сад №130 «Деснянские звездочки» на 335 мест', 'branch': 'Детские сады', 'address': '241004, г. Брянск, пр-т Московский, 148а', 'latitude': '53.20658507123224', 'longitude': '34.46105399999996', 'year': '2015 год', 'finance': '277,8 млн рублей', 'federalBudget': '225,2 млн рублей' }, { 'id': '20', 'object': 'Реконструкция здания под МБДОУ детский сад №82 «Одуванчик» на 112 мест', 'branch': 'Детские сады', 'address': 'г. Брянск, пер. Почтовый, 81', 'latitude': '53.330380571116606,', 'longitude': '34.2886764999999', 'year': '2015 год', 'finance': '50,6 млн рублей', 'federalBudget': '28,5 млн рублей' }, { 'id': '21', 'object': 'Строительство МБДОУ Брасовского района Локотской детский сад № 5 на 150 мест', 'branch': 'Детские сады', 'address': 'Брасовский р-он, н.п. Локоть, пр-т Ленина, 12', 'latitude': '52.56415872965548', 'longitude': '34.579128002655025', 'year': '2015 год', 'finance': '99,0 млн рублей', 'federalBudget': '75,4 млн рублей' }, { 'id': '22', 'object': 'Строительство МБДОУ детский сад №21 «Десняночка» на 110 мест', 'branch': 'Детские сады', 'address': '241047 г. Брянск, ул.Горняков, 1', 'latitude': '53.251046071173086', 'longitude': '34.454541500000026', 'year': '2015 год', 'finance': '98,5 млн рублей', 'federalBudget': '60,2 млн рублей' }, { 'id': '23', 'object': 'Строительство МБДОУ детский сад №15 «Ягодка» на 75 мест', 'branch': 'Детские сады', 'address': 'г. Брянск р.п. Большое Полпино, ул.Центральная, 72б', 'latitude': '53.239482071201145', 'longitude': '34.50210699999995', 'year': '2015 год', 'finance': '77,5 млн рублей', 'federalBudget': '34,6 млн рублей' }, { 'id': '24', 'object': 'Реконструкция стадиона «Нерусса» на 1925 мест', 'branch': 'Спорт', 'address': 'г. Трубчевск, ул. Урицкого, 65', 'latitude': '52.57630053868566', 'longitude': '33.76878585581965', 'year': '2015 год', 'finance': '159,0 млн рублей', 'federalBudget': '103,4 млн рублей' }, { 'id': '25', 'object': 'Строительство канализационных очистных сооружения (3080 м3/сутки)', 'branch': 'Инфраструктура', 'address': 'Брянский район, д. Добрунь, ул. Зеленая, 42', 'latitude': '53.19355257122762', 'longitude': '34.25323799999996', 'year': '2016 год', 'finance': '262,6 млн рублей', 'federalBudget': '197,5 млн рублей' }, { 'id': '26', 'object': 'Пристройка к МБОУ СОШ №2 на 500 мест', 'branch': 'Образование', 'address': 'Клетнянский район, п. Клетня, ул. Вокзальная, 26 ', 'latitude': '53.394632571050096', 'longitude': '33.207760499999985', 'year': '2016 год', 'finance': '163,5 млн рублей', 'federalBudget': '77,7 млн рублей' }, { 'id': '27', 'object': 'Пристройка к МБОУ «Лицей № 27 им. Героя Советского Союза И.Е. Кустова» на 600 мест', 'branch': 'Образование', 'address': '241020 г. Брянск, пр-т Московский, 64 ', 'latitude': '53.212776071190326', 'longitude': '34.42542699999998', 'year': '2016 год', 'finance': '217,4 млн рублей', 'federalBudget': '147,7 млн рублей' }, { 'id': '28', 'object': 'Строительство плоскостных сооружений в СОШ №1 г. Севска (2089 кв. м)', 'branch': 'Спорт', 'address': 'г. Севск, ул. Р. Люксембург, 1', 'latitude': '52.15613307197673', 'longitude': '34.505826', 'year': '2016 год', 'finance': '5,6 млн рублей', 'federalBudget': '5,4 млн рублей' }, { 'id': '29', 'object': 'Реконструкция путепровода через железнодорожные пути станции Брянск 1 (мост 0,1 км с подходами 0,3 км)', 'branch': 'Дороги', 'address': 'Володарский район, г. Брянск', 'latitude': '53.260078971913934', 'longitude': '34.40896242925253', 'year': '2016 год', 'finance': '249,3 млн рублей', 'federalBudget': '91,5 млн рублей' }, { 'id': '30', 'object': 'Реконструкция Первомайского моста через р. Десна (мост 0,271 км с подходами 1,3 км)', 'branch': 'Дороги', 'address': 'Бежицкий район, г. Брянск (1 пусковой комплекс)', 'latitude': '53.29274805405929', 'longitude': '34.306190581020324', 'year': '2016 год', 'finance': '369,8 млн рублей', 'federalBudget': '289,2 млн рублей' }, { 'id': '32', 'object': 'Реконструкция Семеновского сквера', 'branch': 'Благоустройство', 'address': '241050, г. Брянск, ул. Энергетическая, 101', 'latitude': '53.24112314796103', 'longitude': '34.372202993392925', 'year': '2017 год', 'finance': '29,13 млн рублей', 'federalBudget': '24,63 млн рублей' }, { 'id': '33', 'object': 'Реконструкция парка им. Пушкина', 'branch': 'Благоустройство', 'address': '241035, г. Брянск, ул. Ульянова, 37', 'latitude': '53.30994266837953', 'longitude': '34.31346670765684', 'year': '2017 год', 'finance': '13,53 млн рублей', 'federalBudget': '11,44 млн рублей' }, { 'id': '34', 'object': 'Мост через р. Десна на&nbsp;автомобильной дороге &laquo;Брянск&nbsp;&mdash; Смоленск&raquo;&nbsp;&mdash; Жуковка', 'branch': 'Дороги', 'address': 'Брянская область, Жуковский район', 'latitude': '53.498797', 'longitude': '33.699293', 'year': '2017 год', 'finance': '327 млн рублей', 'federalBudget': '151 млн рублей' }, { 'id': '35', 'object': 'Перинатальный центр ГАУЗ &laquo;Брянская городская больница №1&raquo;', 'branch': 'Здравоохранение', 'address': '241035, г. Брянск, ул.&nbsp;Камозина, д.&nbsp;11', 'latitude': '53.29998692785484', 'longitude': '34.29771476751832', 'year': '2017 год', 'finance': '2,21 млрд рублей', 'federalBudget': '1,77 млрд рублей' }, { 'id': '36', 'object': 'Пристройка на 500 мест к МБОУ «Снежская гимназия» Брянская область', 'branch': 'Образование', 'address': 'Брянская область, Брянский р-н, Снежское сельское поселение, посёлок Путёвка, ул. Школьная, д. 1', 'latitude': '53.261652736449754', 'longitude': '34.295115415344206', 'year': '2017 год', 'finance': '171,08 млн рублей', 'federalBudget': '153,93 млн рублей' }, { 'id': '37', 'object': 'МБОУ Стародубская cредняя общеобразовательная школа № 3 Брянская область (строительство и оборудование)', 'branch': 'Образование', 'address': 'Брянская область, г. Стародуб, пер. Красноармейский, 7а', 'latitude': '52.58919114017621', 'longitude': '32.763096228836076', 'year': '2017 год', 'finance': '252,79  млн рублей', 'federalBudget': '221,54 млн рублей' }, { 'id': '38', 'object': 'МБОУ Свенская средняя общеобразовательная школа № 1', 'branch': 'Образование', 'address': 'Брянская область, Брянский р-н,  п. Свень-Транспортная, Транспортный пер., 4а', 'latitude': '53.16960907125277', 'longitude': '34.353777499999936 ', 'year': '2017 год', 'finance': '167,64  млн рублей', 'federalBudget': '144,31 млн рублей' }]);
// EXTERNAL MODULE: ./node_modules/ismobilejs/isMobile.js
var isMobile = __webpack_require__("Sst2");
var isMobile_default = /*#__PURE__*/__webpack_require__.n(isMobile);

// CONCATENATED MODULE: ./src/components/ymaps-touch-scroll.js


function ymapsTouchScroll(map) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!isMobile_default.a || !isMobile_default.a.any || !map.behaviors.isEnabled('multiTouch')) return;

  map.behaviors.disable('drag');

  var parentBlock = map.container.getParentElement();

  if (!getComputedStyle(parentBlock).position) parentBlock.style.position = 'relative';

  function createEl(elClass, appendBlock, elStyles) {
    var el = document.createElement('div');

    for (var key in elStyles) {
      el.style[key] = elStyles[key];
    }el.classList.add(elClass);

    appendBlock.appendChild(el);

    return el;
  }

  var mapZIndex = getComputedStyle(map.container.getElement()).zIndex;

  var block = createEl('ymaps-touch-scroll', parentBlock, {
    position: 'absolute',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    zIndex: mapZIndex - 1
  });

  var bg = createEl('ymaps-touch-scroll-bg', block, {
    background: '#000',
    opacity: '0',
    width: '100%',
    height: '100%',
    transition: 'opacity .1s ease-in-out'
  });

  var mapMargin = map.margin.getMargin();
  for (var i in mapMargin) {
    mapMargin[i] += 20;
  }var content = createEl('ymaps-touch-scroll-content', block, {
    position: 'absolute',
    top: '50%',
    left: '0',
    transform: 'translateY(-50%)',
    color: '#fff',
    textAlign: 'center',
    width: '100%',
    overflow: 'hidden',
    boxSizing: 'border-box',
    textOverflow: 'ellipsis',
    padding: mapMargin.join('px ') + 'px'
  });

  content.textContent = options.hasOwnProperty('text') ? options.text : 'Чтобы переместить карту проведите по ней двумя пальцами';

  function blockToggle() {
    var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    block.style.zIndex = show ? mapZIndex : mapZIndex - 1;
    bg.style.opacity = show ? '.5' : 0;
  }

  parentBlock.addEventListener('touchmove', function () {
    return blockToggle();
  });

  parentBlock.addEventListener('touchend', function () {
    return blockToggle(false);
  });
}
// CONCATENATED MODULE: ./src/Utils.js
/* harmony default export */ var Utils = ({
  getDocumentWidth: function getDocumentWidth() {
    var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    return width;
  },
  getDocumentHeight: function getDocumentHeight() {
    var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    return height;
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MyMap.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MyMap = ({
  name: 'myMap',
  data: function data() {
    return {};
  },

  computed: {
    controls: function controls() {
      var desktop = ['typeSelector', 'zoomControl', 'fullscreenControl'];
      var controls = desktop;
      if (isMobile_default.a.phone) {
        desktop.pop();
        controls = desktop;
      }
      return controls;
    },
    placemarks: function placemarks() {
      return objects.map(function (item) {
        var nmb = '0' + item.id;
        nmb = nmb.slice(-2);
        var imagePath = __webpack_require__("S3ov")("./" + nmb + '-s.jpg');
        // let srcset = require(imagePath + nmb + '-s.jpg') + ''
        var balloonMinHeight = 320;
        var balloonMinWidth = 320;
        var height = Utils.getDocumentHeight();
        var width = Utils.getDocumentWidth();
        if (width >= 576) {
          imagePath = __webpack_require__("1Cu7")("./" + nmb + '-m.jpg');
          if (!isMobile_default.a.phone) {
            balloonMinWidth = 576;
            balloonMinHeight = 426;
          }
        }
        if (width >= 1400) {
          imagePath = __webpack_require__("ySjQ")("./" + nmb + '-l.jpg');
          if (!isMobile_default.a.phone) {
            balloonMinWidth = 992;
            balloonMinHeight = 600;
          }
        }
        var text = item.object + '<br/>Стоимость объекта - ' + item.finance + ', доля федерального бюджета - ' + item.federalBudget;
        var generatePreset = function generatePreset(branch) {
          var category = {
            'Благоустройство': 'islands#blueHydroCircleIcon',
            'Детские сады': 'islands#blueFamilyCircleIcon',
            'Дороги': 'islands#blueAutoCircleIcon',
            'Здравоохранение': 'islands#blueMedicalCircleIcon',
            'Инфраструктура': 'islands#blueFactoryCircleIcon',
            'Образование': 'islands#blueEducationCircleIcon',
            'Спорт': 'islands#blueSportCircleIcon'
          };
          return category[branch];
        };
        var generateBalloonContent = function generateBalloonContent(image, text, address) {
          return '<div class="balloon-table">' + ' <div class="balloon-table__body">' + ' <div class="balloon-table__row">' + ' <div class="balloon-table__cell ballon-table__image_default" style="background-image:url(' + image + ')">&nbsp;</div>' + ' </div>' + ' <div class="balloon-table__row">' + ' <div class="balloon-table__cell ballon-table__text_default">' + text + '</div>' + ' </div>' + ' <div class="balloon-table__row">' + ' <div class="balloon-table__cell ballon-table__address_default">' + address + '</div>' + ' </div>' + ' </div>' + ' </div>';
        };

        return {
          coords: [item.latitude, item.longitude],
          properties: {
            /*            ballonContentHeader: item.branch, */
            /*            balloonContentBody: '<img height="auto" width="100%" src="' +
                        imagePath + '"/><div>' + item.object +
                          '<br/>Стоимость объекта - ' + item.finance + ', доля федерального бюджета - ' + item.federalBudget +
                          '</div>',
             */
            balloonContentBody: generateBalloonContent(imagePath, text, item.address),
            /*            balloonContentFooter: item.address, */
            clusterCaption: item.address
          },
          options: {
            //  balloonPane: 'outerBalloon',
            iconColor: '#163f5f',
            balloonCloseButton: true,
            ballonAutoPan: true,
            ballonAutoPanCheckZoomRange: true,
            preset: generatePreset(item.branch),
            balloonMinHeight: balloonMinHeight,
            balloonMinWidth: balloonMinWidth,
            balloonMaxHeight: height * 0.7,
            /*
            balloonMinHeight: 450,
            balloonMinWidth: 600,
            */
            balloonPanelMaxHeightRatio: 0.7,
            balloonPanelMaxMapArea: isMobile_default.a.phone ? Infinity : 0
          },
          clusterName: '1'
        };
      });
    }
  },
  methods: {
    initHandler: function initHandler(map) {
      ymapsTouchScroll(map);
    }
  },
  components: {
    yandexMap: vue_yandex_maps["yandexMap"], ymapMarker: vue_yandex_maps["ymapMarker"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e37f3cce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyMap.vue
var MyMap_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('yandex-map',{attrs:{"coords":[53.2282985712013, 34.31553600000001],"zoom":"8","cluster-options":{
  1: {clusterDisableClickZoom: false,
  clusterBalloonContentBodyLayout: 'cluster#balloonAccordionContent'
  }
  },"controls":_vm.controls,"placemarks":_vm.placemarks,"behaviors":['drag', 'dblClickZoom', 'rightMouseButtonMagnifier', 'multiTouch'],"map-type":"map","scroll-zoom":false},on:{"map-was-initialized":_vm.initHandler}})}
var MyMap_staticRenderFns = []
var MyMap_esExports = { render: MyMap_render, staticRenderFns: MyMap_staticRenderFns }
/* harmony default export */ var components_MyMap = (MyMap_esExports);
// CONCATENATED MODULE: ./src/components/MyMap.vue
function MyMap_injectStyle (ssrContext) {
  __webpack_require__("BUc/")
}
var MyMap_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MyMap___vue_template_functional__ = false
/* styles */
var MyMap___vue_styles__ = MyMap_injectStyle
/* scopeId */
var MyMap___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MyMap___vue_module_identifier__ = null
var MyMap_Component = MyMap_normalizeComponent(
  MyMap,
  components_MyMap,
  MyMap___vue_template_functional__,
  MyMap___vue_styles__,
  MyMap___vue_scopeId__,
  MyMap___vue_module_identifier__
)

/* harmony default export */ var src_components_MyMap = (MyMap_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Indicator.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Indicator = ({
  name: 'indicator',
  props: ['image'],
  computed: {
    background: function background() {
      return {
        'background-image': this.image
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee566db8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Indicator.vue
var Indicator_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"bem",rawName:"v-bem",value:('background'),expression:"'background'"}]},[_c('div',{directives:[{name:"bem",rawName:"v-bem.description",value:('default'),expression:"'default'",modifiers:{"description":true}}]},[_c('div',{directives:[{name:"bem",rawName:"v-bem.skew-top",value:('default'),expression:"'default'",modifiers:{"skew-top":true}}]}),_c('div',{directives:[{name:"bem",rawName:"v-bem.skew-bottom",value:('default'),expression:"'default'",modifiers:{"skew-bottom":true}}]}),_vm._v(" "),_c('div',{directives:[{name:"bem",rawName:"v-bem.image",value:('default'),expression:"'default'",modifiers:{"image":true}}],style:(_vm.background)},[_vm._v(" ")]),_vm._v(" "),_c('div',{directives:[{name:"bem",rawName:"v-bem.digit",value:('default'),expression:"'default'",modifiers:{"digit":true}}]},[_vm._t("digit")],2),_vm._v(" "),_c('div',{directives:[{name:"bem",rawName:"v-bem.full-info",value:('default'),expression:"'default'",modifiers:{"full-info":true}}]},[_vm._t("default",[_vm._v("\n         Текст \n        ")])],2)]),_vm._v(" "),_c('div',{directives:[{name:"bem",rawName:"v-bem.right-image",value:('default'),expression:"'default'",modifiers:{"right-image":true}}],style:(_vm.background)},[_c('div',{directives:[{name:"bem",rawName:"v-bem.right-arrow",value:('default'),expression:"'default'",modifiers:{"right-arrow":true}}]})])])}
var Indicator_staticRenderFns = []
var Indicator_esExports = { render: Indicator_render, staticRenderFns: Indicator_staticRenderFns }
/* harmony default export */ var components_Indicator = (Indicator_esExports);
// CONCATENATED MODULE: ./src/components/Indicator.vue
function Indicator_injectStyle (ssrContext) {
  __webpack_require__("Xx8z")
}
var Indicator_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Indicator___vue_template_functional__ = false
/* styles */
var Indicator___vue_styles__ = Indicator_injectStyle
/* scopeId */
var Indicator___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Indicator___vue_module_identifier__ = null
var Indicator_Component = Indicator_normalizeComponent(
  Indicator,
  components_Indicator,
  Indicator___vue_template_functional__,
  Indicator___vue_styles__,
  Indicator___vue_scopeId__,
  Indicator___vue_module_identifier__
)

/* harmony default export */ var src_components_Indicator = (Indicator_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CiteBlock.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var CiteBlock = ({
  name: 'cite-block',
  props: ['text', 'description']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a05704f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CiteBlock.vue
var CiteBlock_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"bem",rawName:"v-bem",value:('default'),expression:"'default'"}]},[_c('div',{directives:[{name:"bem",rawName:"v-bem.photo-wrapper",value:('default'),expression:"'default'",modifiers:{"photo-wrapper":true}}]},[_c('img',{directives:[{name:"bem",rawName:"v-bem.photo",value:('default'),expression:"'default'",modifiers:{"photo":true}}],attrs:{"src":__webpack_require__("HV7/")}}),_c('div',{directives:[{name:"bem",rawName:"v-bem.author",value:('default'),expression:"'default'",modifiers:{"author":true}}]},[_vm._v("Владимир Путин:")])]),_vm._v(" "),_c('div',{directives:[{name:"bem",rawName:"v-bem.text",value:('default'),expression:"'default'",modifiers:{"text":true}}],domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._v(" "),_c('div',{directives:[{name:"bem",rawName:"v-bem.description",value:('default'),expression:"'default'",modifiers:{"description":true}}],domProps:{"innerHTML":_vm._s(_vm.description)}})])}
var CiteBlock_staticRenderFns = []
var CiteBlock_esExports = { render: CiteBlock_render, staticRenderFns: CiteBlock_staticRenderFns }
/* harmony default export */ var components_CiteBlock = (CiteBlock_esExports);
// CONCATENATED MODULE: ./src/components/CiteBlock.vue
function CiteBlock_injectStyle (ssrContext) {
  __webpack_require__("FBBE")
}
var CiteBlock_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var CiteBlock___vue_template_functional__ = false
/* styles */
var CiteBlock___vue_styles__ = CiteBlock_injectStyle
/* scopeId */
var CiteBlock___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CiteBlock___vue_module_identifier__ = null
var CiteBlock_Component = CiteBlock_normalizeComponent(
  CiteBlock,
  components_CiteBlock,
  CiteBlock___vue_template_functional__,
  CiteBlock___vue_styles__,
  CiteBlock___vue_scopeId__,
  CiteBlock___vue_module_identifier__
)

/* harmony default export */ var src_components_CiteBlock = (CiteBlock_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/StartScreen.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var StartScreen = ({
  name: 'start-screen',
  props: []
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df122d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StartScreen.vue
var StartScreen_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"bem",rawName:"v-bem.container",modifiers:{"container":true}},{name:"bg-set",rawName:"v-bg-set"}],style:({backgroundImage: 'url(' + __webpack_require__("atN/") + ')'}),attrs:{"data-bg-src-ms":__webpack_require__("tIRK"),"data-bg-src-ls":__webpack_require__("Ahn9"),"data-bg-src-xs":__webpack_require__("e5uJ")}},[_c('div',{directives:[{name:"bem",rawName:"v-bem.strip",value:({'default': true, 'left': true}),expression:"{'default': true, 'left': true}",modifiers:{"strip":true}}]}),_vm._v(" "),_c('div',{directives:[{name:"bem",rawName:"v-bem.strip",value:({'default': true, 'top': true}),expression:"{'default': true, 'top': true}",modifiers:{"strip":true}}]}),_vm._v(" "),_c('div',{directives:[{name:"bem",rawName:"v-bem.strip",value:({'default': true, 'right': true}),expression:"{'default': true, 'right': true}",modifiers:{"strip":true}}]}),_vm._v(" "),_c('div',{directives:[{name:"bem",rawName:"v-bem.strip",value:({'default': true, 'bottom': true}),expression:"{'default': true, 'bottom': true}",modifiers:{"strip":true}}]}),_vm._v(" "),_c('div',{directives:[{name:"bem",rawName:"v-bem.coverage",value:({'full':true,'gradient':true}),expression:"{'full':true,'gradient':true}",modifiers:{"coverage":true}}]},[_c('div',{directives:[{name:"bem",rawName:"v-bem.standart",value:('default'),expression:"'default'",modifiers:{"standart":true}}]},[_c('img',{directives:[{name:"bem",rawName:"v-bem.standart-img",value:('default'),expression:"'default'",modifiers:{"standart-img":true}}],attrs:{"src":__webpack_require__("ftnl")}})]),_vm._v(" "),_c('div',{directives:[{name:"bem",rawName:"v-bem.main-title",value:('default'),expression:"'default'",modifiers:{"main-title":true}}]},[_vm._v("Cтратегические инициативы Президента России ")])])])}
var StartScreen_staticRenderFns = []
var StartScreen_esExports = { render: StartScreen_render, staticRenderFns: StartScreen_staticRenderFns }
/* harmony default export */ var components_StartScreen = (StartScreen_esExports);
// CONCATENATED MODULE: ./src/components/StartScreen.vue
function StartScreen_injectStyle (ssrContext) {
  __webpack_require__("Mk9A")
}
var StartScreen_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var StartScreen___vue_template_functional__ = false
/* styles */
var StartScreen___vue_styles__ = StartScreen_injectStyle
/* scopeId */
var StartScreen___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var StartScreen___vue_module_identifier__ = null
var StartScreen_Component = StartScreen_normalizeComponent(
  StartScreen,
  components_StartScreen,
  StartScreen___vue_template_functional__,
  StartScreen___vue_styles__,
  StartScreen___vue_scopeId__,
  StartScreen___vue_module_identifier__
)

/* harmony default export */ var src_components_StartScreen = (StartScreen_Component.exports);

// CONCATENATED MODULE: ./src/indicators.js
/* harmony default export */ var indicators = ([{
  duration: 3,
  start: 0,
  end: 477,
  decimals: 0,
  postfix: 'врачей&nbsp;&mdash;',
  description: 'молодых специалистов пришли работать в медицинские учреждения Брянской области с&nbsp;2013 по 2017 год.',
  image: __webpack_require__("7PdY"),
  cite: {
    text: 'Смысл всей нашей политики&nbsp;&mdash; это сбережение людей, умножение человеческого капитала как главного богатства России. Поэтому наши усилия направлены на&nbsp;поддержку традиционных ценностей и&nbsp;семьи, на&nbsp;демографические программы, улучшение экологии, здоровья людей, развитие образования и&nbsp;культуры.',
    description: 'Послание Президента Федеральному Собранию, 1&nbsp;декабря 2016 года'
  }
}, {
  duration: 3,
  start: 0,
  end: 240,
  decimals: 0,
  postfix: 'специалистов',
  description: 'получили выплату в&nbsp;размере 1&nbsp;млн&nbsp;рублей с&nbsp;2012 года в&nbsp;рамках реализации федеральной программы &laquo;Земский доктор&raquo;. ',
  image: __webpack_require__("xsgK")

}, {
  duration: 3,
  start: 0,
  end: 82,
  decimals: 0,
  postfix: 'автомобиля',
  description: 'скорой помощи получили учреждения здравоохранения Брянской области с&nbsp;2015&nbsp;года.',
  image: __webpack_require__("7rD+")
}, {
  duration: 3,
  start: 0,
  end: 94,
  decimals: 0,
  postfix: 'автобуса,',
  description: 'сертифицированных для перевозки детей, переданы общеобразовательным учреждениям  Брянской области за&nbsp;последние 2&nbsp;года.',
  image: __webpack_require__("yyfU")
}, {
  duration: 3,
  start: 0,
  end: 135,
  decimals: 0,
  postfix: ' участников',
  description: 'представили Брянскую область на&nbsp;XIX Всемирном фестивале молодежи и&nbsp;студентов.',
  image: __webpack_require__("0HEY")
}, {
  duration: 3,
  start: 0,
  end: 9677,
  decimals: 0,
  postfix: ' рублей',
  description: 'будут ежемесячно получать семьи в&nbsp;Брянской области при рождении (усыновлении) первого ребенка после 1 января 2018 года, в&nbsp;случае если среднедушевой доход семьи не&nbsp;превышает прожиточный минимум в&nbsp;полтора раза. Решение о&nbsp;назначении выплат принято Президентом РФ&nbsp;В. Путиным на&nbsp;заседании Координационного совета по&nbsp;реализации Национальной стратегии действий в&nbsp;интересах детей 28 ноября 2017 года.',
  image: __webpack_require__("SF5G"),
  cite: {
    text: 'Среди мер, которые были введены и&nbsp;которые работают до&nbsp;сих пор, особую роль сыграла программа материнского капитала. <..> Иметь в&nbsp;семье двух детей стало устойчивой тенденцией. Снизилась младенческая смертность, благодаря созданию системы перинатальных центров, прежде всего, удалось выйти на&nbsp;плюсовые показатели естественного прироста населения.',
    description: 'Заседание Координационного совета по&nbsp;реализации Национальной стратегии действий в&nbsp;интересах детей, 29&nbsp;ноября&nbsp;2017&nbsp;года'
  }
}, {
  duration: 3,
  start: 50000,
  end: 65449,
  decimals: 0,
  postfix: 'сертификатов',
  description: 'выдано в Брянской области на материнский семейный капитал c 1 января 2007 года. В 2018 году материнский капитал составляет 453 026 рублей и выдается при при рождении или усыновлении второго, третьего или последующего ребёнка.',
  image: __webpack_require__("v4Yc")
}, {
  duration: 3,
  start: 0,
  end: 100,
  decimals: 0,
  postfix: '% детей',
  description: 'в&nbsp;возрасте от&nbsp;3 до&nbsp;7 лет обеспечены местами в&nbsp;детских садах Брянской области.',
  image: __webpack_require__("4ZqJ")
}, {
  duration: 3,
  start: 0,
  end: 249.3,
  decimals: 1,
  postfix: '&nbsp;млн&nbsp;рублей',
  description: 'получила Брянская область благодаря системе &laquo;Платон&raquo; на&nbsp;ремонт дорог и&nbsp;мостов.',
  image: __webpack_require__("Xz/J"),
  cite: {
    text: '&laquo;Одним из&nbsp;приоритетов в&nbsp;работе Правительства, вообще государства в&nbsp;ближайшее время должна стать работа над развитием инфраструктуры. Это дорожная сеть, аэропорты, порты, связь.&raquo',
    description: 'Ежегодная пресс-конференция Президента России, 14&nbsp;декабря&nbsp;2017&nbsp;года'
  }
}, {
  duration: 3,
  start: 0,
  end: 510,
  decimals: 0,
  postfix: 'км автодорог',
  description: 'будет построено и&nbsp;капитально отремонтировано в&nbsp;2018 году (в&nbsp;2017 году&nbsp;&mdash; 470&nbsp;км). Объем строительства и&nbsp;ремонта дорог вырос более чем в&nbsp;три раза, хотя бюджет дорожного фонда увеличился только на&nbsp;40%.',
  image: __webpack_require__("tIRK")
}, {
  duration: 3,
  start: 0,
  end: 300,
  decimals: 0,
  postfix: 'населенных пунктов',
  description: 'с&nbsp;численностью жителей от&nbsp;250 до&nbsp;500 человек будут подключены к&nbsp;высокоскоростному Интернету благодаря соглашению между Минкомсвязью, Брянской областью и&nbsp;<nobr>ПАО &laquo;Ростелеком&raquo;</nobr>.',
  image: __webpack_require__("T8ql")
}]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var App = ({
  name: 'app',
  mounted: function mounted() {
    if (isMobile_default.a.phone || Utils.getDocumentWidth() < 768) {
      // this.$nextTick(this.pinContainerScene2)
      this.slide = 2;
      this.$nextTick(this.mobileAnimation);
    } else {
      this.$nextTick(this.pinContainerScene2);
    }
  },
  data: function data() {
    return {
      indicators: indicators,
      multiTouch: isMobile_default.a.phone || isMobile_default.a.tablet,
      phone: isMobile_default.a.phone,
      tablet: isMobile_default.a.tablet,
      startCount: false,
      slide: 1
    };
  },

  components: {
    CounterUp: src_components_CounterUp, MyMap: src_components_MyMap, Indicator: src_components_Indicator, CiteBlock: src_components_CiteBlock, StartScreen: src_components_StartScreen
  },
  methods: {
    formatIndicators: function formatIndicators(value, postfix) {
      var val = value.toFixed(0).replace('.', ',');
      var fval = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return fval + ' ' + postfix;
    },
    completed: function completed() {
      // console.log('completed')
      this.slide++;
    },
    startAnimation: function startAnimation() {
      this.startCount = !this.startCount;
    },
    initHandler: function initHandler() {},
    checkCite: function checkCite(index) {
      return index % 3 === 0;
    },
    addScene: function addScene() {
      // console.dir(arguments)
    },
    mobileAnimation: function mobileAnimation() {
      console.log('mobile animation');
    },
    pinContainerScene2: function pinContainerScene2() {
      var _this = this;

      var tl = new this.$gsap.TimelineMax();
      var duration = 2;
      tl.add('first', 0);
      tl.add('real', 1);
      tl.add('second', duration);
      tl.to('.start-screen__coverage', duration, { css: { className: 'start-screen__coverage_full start-screen__coverage' } });
      tl.from('.start-screen__strip_left', duration, { right: '0%', bottom: '0%', transform: 'rotateZ(0deg)' }, 'first');
      tl.from('.start-screen__strip_top', duration, { left: '100%', bottom: '0%', transform: 'rotateZ(0deg)', opacity: 1 }, 'first');
      tl.from('.start-screen__strip_right', duration, { left: '100%', top: '100%', transform: 'rotateZ(0deg)', opacity: 1 }, 'first');
      tl.from('.start-screen__strip_bottom', duration, { right: '0%', top: '100%', transform: 'rotateZ(0deg)', opacity: 1 }, 'first');
      tl.from('.real-bryansk_default', duration, { opacity: 0 }, 'real');
      // tl.to('div.standart', duration, {left: '0%', transform: 'scale(0.5,0.5)'}, 'first')
      tl.to('div.start-screen__coverage', duration, {
        left: '0',
        top: '0',
        width: '25%',
        height: '20%',
        onComplete: function onComplete() {
          this.slide = 2;
        },
        onCompleteScope: this
      }, 'first');
      tl.to('div.start-screen__main-title', duration, {
        css: {
          className: 'start-screen__main-title start-screen__main-title_left'
        }
      }, 'first');
      tl.to('.start-screen__standart', duration, {
        css: {
          className: 'start-screen__standart  start-screen__standart_left'
        }
      }, 'first');
      /*
      tl.from(
        '.cite-block',
        duration,
        {
          top: '200%',
          ease: this.$gsap.Circ.easeOut
        }
      )
      */
      // create scene and set its params
      var scene = new this.$scrollmagic.Scene({
        triggerElement: '.pinContainer',
        triggerHook: 'onLeave',
        duration: '50%'
      }).setPin('.pinContainer').setTween(tl);

      // Add scene to ScrollMagic controller by emiting an 'addScene' event on vm.$ksvuescr (which is our global event bus)
      this.$ksvuescr.$emit('addScene', 'pinContainerScene2', scene);

      var tl0 = new this.$gsap.TimelineMax();

      var scene0 = new this.$scrollmagic.Scene({
        triggerElement: '.trigger0',
        triggerHook: 0.9,
        duration: '300'
      }).setTween(tl0);

      tl0.from('#cite0', 2, {
        top: '101%'
      });
      tl0.to('.real-bryansk_default', 1, {
        display: 'none'
      });
      this.$ksvuescr.$emit('addScene', 'pinContainerScene2', scene0);
      var keys = [];
      indicators.forEach(function (element, index) {
        if (element.cite && index > 0) {
          keys.push(index);
        }
      });

      var tln = [];
      var scenen = [];
      var prev = 0;
      keys.forEach(function (element) {
        tln[element] = new _this.$gsap.TimelineMax();
        tln[element].add('first', 0);
        scenen[element] = new _this.$scrollmagic.Scene({
          triggerElement: '.trigger' + element,
          triggerHook: 0.9,
          duration: '300'
        }).setTween(tln[element]);
        tln[element].to('#cite' + prev, 2, {
          left: '-40%'
        }, 'first');
        tln[element].from('#cite' + element, 2, {
          top: '101%'
        }, 'first');
        // for rounded digits
        /* tln[element].to(
           this,
           2,
           {slide: element},
           'first'
         ) */
        prev = element;
        _this.$ksvuescr.$emit('addScene', 'pinContainerScene2', scenen[element]);
      });
      /*
            const tl3 = new this.$gsap.TimelineMax()
            tl3.add('first', 0)
      
            const scene3 = new this.$scrollmagic.Scene({
              triggerElement: '.trigger3',
              triggerHook: 0.9,
              duration: '300'
            })
            .setTween(tl3)
      
            tl3.to(
              '#cite0',
              2,
              {
                left: '-40%'
              },
              'first'
            )
            tl3.from(
      
              '#cite3',
              2,
              {
                top: '101%'
              },
              'first'
            )
      
            this.$ksvuescr.$emit('addScene', 'pinContainerScene2', scene3)
      
            const tl7 = new this.$gsap.TimelineMax()
            tl7.add('first', 0)
      
            const scene7 = new this.$scrollmagic.Scene({
              triggerElement: '.trigger7',
              triggerHook: 0.9,
              duration: '300'
            })
            .setTween(tl7)
      
            tl7.to(
              '#cite3',
              2,
              {
                left: '-40%'
              },
              'first'
            )
            tl7.from(
              '#cite7',
              2,
              {
                top: '101%'
              },
              'first'
            )
            this.$ksvuescr.$emit('addScene', 'pinContainerScene2', scene7)
            */
    },
    destroyed: function destroyed() {
      // Destroy ScrollMagic when our component is removed from DOM
      this.$ksvuescr.$emit('destroy');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fe017f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{ref:"pin",staticClass:"pinContainer"},[_c('start-screen')],1),_vm._v(" "),_c('div',{staticClass:"real-bryansk real-bryansk_default"},[_vm._v("Реализация в Брянской области")]),_vm._v(" "),_c('section',{ref:"pin2",staticClass:"pinContainer2 grid-block"},[_c('h1',{staticClass:"grid-block__header"},[_vm._v("Фотофакты")]),_vm._v(" "),_vm._l((_vm.indicators),function(item,index){return _c('div',{},[(item.cite)?[_c('div',{class:'trigger' + index}),_vm._v(" "),_c('cite-block',{attrs:{"id":'cite' + index,"text":item.cite.text,"description":item.cite.description}})]:_vm._e(),_vm._v(" "),(_vm.phone || true ||  _vm.slide>index)?_c('indicator',{attrs:{"image":'url('+ item.image +')'}},[_c('div',{attrs:{"slot":"digit"},slot:"digit"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.formatIndicators(item.end, item.postfix))}})]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(item.description)}})]):_vm._e(),_vm._v(" "),_c('br')],2)})],2),_vm._v(" "),_c('section',{staticClass:"grid-block "},[_c('h1',{staticClass:"grid-block__header"},[_vm._v("Карта фактов")]),_vm._v(" "),(_vm.multiTouch)?_c('div',{staticClass:"map__description"},[_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false)]):_vm._e(),_vm._v(" "),(_vm.slide>1)?_c('my-map',{staticClass:"grid-block__map_default"}):_vm._e()],1)])}
var App_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid__cell"},[_c('div',{staticClass:"global_center"},[_c('img',{attrs:{"src":__webpack_require__("zS2w")}})]),_vm._v(" "),_c('div',{staticClass:"global_center"},[_vm._v("Для сдвига карты вправо-влево, вверх-вниз проведите двумя пальцами")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid__cell"},[_c('div',{staticClass:"global_center"},[_c('img',{attrs:{"src":__webpack_require__("tCG1")}})]),_vm._v(" "),_c('div',{staticClass:"global_center"},[_vm._v("Для изменения масштаба карты")])])}]
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("Bk9O")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./node_modules/v-img/dist/v-img.mjs
!function(){if("undefined"!=typeof document){var e=document.head||document.getElementsByTagName("head")[0],t=document.createElement("style"),n=' *[data-v-5928e1c7] { -webkit-box-sizing: border-box; box-sizing: border-box; } .fullscreen-v-img[data-v-5928e1c7] { z-index: 9999; height: 100%; width: 100%; position: fixed; top: 0; left: 0; overflow: hidden; background-color: rgba(0, 0, 0, 0.7); -ms-touch-action: none; touch-action: none; } .content-v-img img[data-v-5928e1c7] { width: auto; height: auto; max-width: 100%; max-height: 100%; position: absolute; top: 0; left: 0; right: 0; bottom: 0; margin: auto; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; } .header-v-img[data-v-5928e1c7] { position: absolute; width: 100%; background-color: rgba(0, 0, 0, 0.3); height: 50px; z-index: 9999; display: flex; justify-content: space-between; align-items: center; } .title-v-img[data-v-5928e1c7] { font-family: "Avenir", Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 400; color: white; text-align: center; max-height: 100%; overflow: auto; } .count-v-img[data-v-5928e1c7], .buttons-v-img[data-v-5928e1c7] { width: 80px; font-family: "Avenir", Helvetica, Arial, sans-serif; } .count-v-img[data-v-5928e1c7] { font-size: 15px; color: white; margin-left: 10px; } .buttons-v-img[data-v-5928e1c7] { margin-right: 10px; text-align: right; } .buttons-v-img span path[data-v-5928e1c7] { fill: #e5e6eb; -webkit-transition: fill 0.4s ease-in-out; transition: fill 0.4s ease-in-out; } .buttons-v-img span[data-v-5928e1c7] { cursor: pointer; color: #e5e6eb; font-size: 30px; -webkit-transition: color 0.4s ease-in-out; transition: color 0.4s ease-in-out; text-decoration: none; text-align: center; } .buttons-v-img span[data-v-5928e1c7]:not(:last-child) { margin-right: 8px; } .buttons-v-img span svg[data-v-5928e1c7] { height: 20px; width: 15px; } .buttons-v-img span:hover svg path[data-v-5928e1c7] { fill: white; } .buttons-v-img span[data-v-5928e1c7]:hover { color: white; } .prev-v-img svg[data-v-5928e1c7], .next-v-img svg[data-v-5928e1c7] { margin: 5px auto; } .prev-v-img[data-v-5928e1c7], .next-v-img[data-v-5928e1c7] { color: white; width: 35px; height: 35px; position: absolute; top: 50%; margin-top: -12.5px; font-size: 15px; font-family: "Avenir", Helvetica, Arial, sans-serif; text-align: center; background-color: rgba(0, 0, 0, 0.3); z-index: 1000; opacity: 0.3; -webkit-transition: opacity 0.3s ease-in-out; transition: opacity 0.3s ease-in-out; cursor: pointer; } .prev-v-img[data-v-5928e1c7]:hover, .next-v-img[data-v-5928e1c7]:hover { opacity: 1; } .prev-v-img[data-v-5928e1c7] { left: 10px; } .next-v-img[data-v-5928e1c7] { right: 10px; } .v-img-fade-enter[data-v-5928e1c7], .v-img-fade-leave-to[data-v-5928e1c7] { opacity: 0; } .v-img-fade-enter-active[data-v-5928e1c7], .v-img-fade-leave-active[data-v-5928e1c7] { -webkit-transition: opacity 0.3s ease-in-out; transition: opacity 0.3s ease-in-out; } ';t.type="text/css",t.styleSheet?t.styleSheet.cssText=n:t.appendChild(document.createTextNode(n)),e.appendChild(t)}}();var ImgScreen={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("transition",{attrs:{appear:"",name:"v-img-fade"}},[e.closed?e._e():n("div",{staticClass:"fullscreen-v-img",on:{click:function(t){if(t.target!==t.currentTarget)return null;e.close(t)}}},[n("div",{staticClass:"header-v-img"},[n("span",{staticClass:"count-v-img"},[e.images.length>1?n("span",[e._v(e._s(e.currentImageIndex+1)+"/"+e._s(e.images.length)+" ")]):e._e()]),n("span",{staticClass:"title-v-img"},[e._v(e._s(e.titles[e.currentImageIndex]))]),n("div",{staticClass:"buttons-v-img"},[e.sourceButtons[e.currentImageIndex]?n("span",[n("a",{attrs:{href:e.images[e.currentImageIndex],target:"_blank"}},[n("svg",{staticStyle:{"enable-background":"new 0 0 475.078 475.077"},attrs:{xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",version:"1.1",id:"Capa_1",x:"0px",y:"0px",width:"512px",height:"512px",viewBox:"0 0 475.078 475.077","xml:space":"preserve"}},[n("path",{attrs:{d:"M467.083,318.627c-5.324-5.328-11.8-7.994-19.41-7.994H315.195l-38.828,38.827c-11.04,10.657-23.982,15.988-38.828,15.988    c-14.843,0-27.789-5.324-38.828-15.988l-38.543-38.827H27.408c-7.612,0-14.083,2.669-19.414,7.994    C2.664,323.955,0,330.427,0,338.044v91.358c0,7.614,2.664,14.085,7.994,19.414c5.33,5.328,11.801,7.99,19.414,7.99h420.266    c7.61,0,14.086-2.662,19.41-7.99c5.332-5.329,7.994-11.8,7.994-19.414v-91.358C475.078,330.427,472.416,323.955,467.083,318.627z     M360.025,414.841c-3.621,3.617-7.905,5.424-12.854,5.424s-9.227-1.807-12.847-5.424c-3.614-3.617-5.421-7.898-5.421-12.844    c0-4.948,1.807-9.236,5.421-12.847c3.62-3.62,7.898-5.431,12.847-5.431s9.232,1.811,12.854,5.431    c3.613,3.61,5.421,7.898,5.421,12.847C365.446,406.942,363.638,411.224,360.025,414.841z M433.109,414.841    c-3.614,3.617-7.898,5.424-12.848,5.424c-4.948,0-9.229-1.807-12.847-5.424c-3.613-3.617-5.42-7.898-5.42-12.844    c0-4.948,1.807-9.236,5.42-12.847c3.617-3.62,7.898-5.431,12.847-5.431c4.949,0,9.233,1.811,12.848,5.431    c3.617,3.61,5.427,7.898,5.427,12.847C438.536,406.942,436.729,411.224,433.109,414.841z",fill:"#FFFFFF"}}),n("path",{attrs:{d:"M224.692,323.479c3.428,3.613,7.71,5.421,12.847,5.421c5.141,0,9.418-1.808,12.847-5.421l127.907-127.908    c5.899-5.519,7.234-12.182,3.997-19.986c-3.23-7.421-8.847-11.132-16.844-11.136h-73.091V36.543c0-4.948-1.811-9.231-5.421-12.847    c-3.62-3.617-7.901-5.426-12.847-5.426h-73.096c-4.946,0-9.229,1.809-12.847,5.426c-3.615,3.616-5.424,7.898-5.424,12.847V164.45    h-73.089c-7.998,0-13.61,3.715-16.846,11.136c-3.234,7.801-1.903,14.467,3.999,19.986L224.692,323.479z",fill:"#FFFFFF"}})])])]):e._e(),n("span",{on:{click:e.close}},[e._v("×")])])]),n("transition",{attrs:{appear:"",name:"v-img-fade"}},[e.visibleUI&&1!==e.images.length?n("span",{staticClass:"prev-v-img",on:{click:e.prev}},[n("svg",{attrs:{width:"25",height:"25",viewBox:"0 0 1792 1915",xmlns:"http://www.w3.org/2000/svg"}},[n("path",{attrs:{d:"M1664 896v128q0 53-32.5 90.5t-84.5 37.5h-704l293 294q38 36 38 90t-38 90l-75 76q-37 37-90 37-52 0-91-37l-651-652q-37-37-37-90 0-52 37-91l651-650q38-38 91-38 52 0 90 38l75 74q38 38 38 91t-38 91l-293 293h704q52 0 84.5 37.5t32.5 90.5z",fill:"#fff"}})])]):e._e()]),n("transition",{attrs:{appear:"",name:"v-img-fade"}},[e.visibleUI&&1!==e.images.length?n("span",{staticClass:"next-v-img",on:{click:e.next}},[n("svg",{attrs:{width:"25",height:"25",viewBox:"0 0 1792 1915",xmlns:"http://www.w3.org/2000/svg"}},[n("path",{attrs:{d:"M1600 960q0 54-37 91l-651 651q-39 37-91 37-51 0-90-37l-75-75q-38-38-38-91t38-91l293-293h-704q-52 0-84.5-37.5t-32.5-90.5v-128q0-53 32.5-90.5t84.5-37.5h704l-293-294q-38-36-38-90t38-90l75-75q38-38 90-38 53 0 91 38l651 651q37 35 37 90z",fill:"#fff"}})])]):e._e()]),n("div",{staticClass:"content-v-img"},[n("img",{attrs:{src:e.images[e.currentImageIndex]},on:{click:e.next}})])],1)])},staticRenderFns:[],_scopeId:"data-v-5928e1c7",data:function(){return{images:[],titles:[],sourceButtons:[],visibleUI:!0,currentImageIndex:0,closed:!0,uiTimeout:null,handlers:{}}},watch:{closed:function(e){e&&this.handlers.closed&&this.handlers.closed(),!e&&this.handlers.opened&&this.handlers.opened()}},methods:{fireChangeEvent:function(){this.handlers.changed&&this.handlers.changed(this.currentImageIndex)},close:function(){this.closed||(document.querySelector("body").classList.remove("body-fs-v-img"),this.images=[],this.currentImageIndex=0,this.closed=!0)},next:function(){!this.closed&&this.images.length>1&&(this.currentImageIndex+1<this.images.length?this.currentImageIndex++:this.currentImageIndex=0,this.fireChangeEvent())},prev:function(){!this.closed&&this.images.length>1&&(this.currentImageIndex>0?this.currentImageIndex--:this.currentImageIndex=this.images.length-1,this.fireChangeEvent())},showUI:function(){var e=this;this.closed||(clearTimeout(this.uiTimeout),this.visibleUI=!0,this.uiTimeout=setTimeout(function(){e.visibleUI=!1},3500))}},created:function(){var e=this;window.addEventListener("keyup",function(t){27!==t.keyCode&&81!==t.keyCode||e.close(),39!==t.keyCode&&76!==t.keyCode||e.next(),37!==t.keyCode&&72!==t.keyCode||e.prev()}),window.addEventListener("scroll",function(){e.close()}),window.addEventListener("mousemove",function(){e.showUI()})}},babelHelpers={},asyncGenerator=function(){function e(e){this.value=e}function t(t){function n(a,r){try{var o=t[a](r),s=o.value;s instanceof e?Promise.resolve(s.value).then(function(e){n("next",e)},function(e){n("throw",e)}):i(o.done?"return":"normal",o.value)}catch(e){i("throw",e)}}function i(e,t){switch(e){case"return":a.resolve({value:t,done:!0});break;case"throw":a.reject(t);break;default:a.resolve({value:t,done:!1})}(a=a.next)?n(a.key,a.arg):r=null}var a,r;this._invoke=function(e,t){return new Promise(function(i,o){var s={key:e,arg:t,resolve:i,reject:o,next:null};r?r=r.next=s:(a=r=s,n(e,t))})},"function"!=typeof t.return&&(this.return=void 0)}return"function"==typeof Symbol&&Symbol.asyncIterator&&(t.prototype[Symbol.asyncIterator]=function(){return this}),t.prototype.next=function(e){return this._invoke("next",e)},t.prototype.throw=function(e){return this._invoke("throw",e)},t.prototype.return=function(e){return this._invoke("return",e)},{wrap:function(e){return function(){return new t(e.apply(this,arguments))}},await:function(t){return new e(t)}}}(),_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(e[i]=n[i])}return e},toConsumableArray=function(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)},addPluginAttributes=function(e,t,n){var i="pointer",a=t.arg||null,r=void 0,o=void 0,s=e.src,c=void 0,l={};return n.altAsTitle&&(c=e.alt),r=n.openOn,o=n.sourceButton,void 0!==t.value&&(i=t.value.cursor||i,a=t.value.group||a,r=t.value.openOn||r,s=t.value.src||s,c=t.value.title||c,void 0!==t.value.sourceButton&&(o=t.value.sourceButton),l.opened=t.value.opened,l.closed=t.value.closed,l.changed=t.value.changed),e.setAttribute("data-vue-img-src",s),a&&e.setAttribute("data-vue-img-group",a),c&&e.setAttribute("data-vue-img-title",c),o&&e.setAttribute("data-vue-img-source-button",o),s||console.error("v-img element missing src parameter."),e.style.cursor=i,{cursor:i,src:s,group:a,title:c,events:l,sourceButton:o,openOn:r}},v_img_install=function(e,t){var n=e.extend(ImgScreen);t=_extends({altAsTitle:!1,sourceButton:!1,openOn:"click"},t),e.directive("img",{update:function(e,n,i,a){var r=void 0,o=void 0;a.data.attrs&&i.data.attrs&&(o=a.data.attrs.src!==i.data.attrs.src,t.altAsTitle&&(r=a.data.attrs.alt!==i.data.attrs.alt));var s=n.oldValue!==n.value;(o||r||s)&&addPluginAttributes(e,n,t)},bind:function(i,a){var r=addPluginAttributes(i,a,t),o=window.vueImg;if(!o){var s=document.createElement("div");s.setAttribute("id","imageScreen"),document.querySelector("body").appendChild(s),o=window.vueImg=(new n).$mount("#imageScreen")}i.addEventListener(r.openOn,function(){var t=void 0;t=i.dataset.vueImgGroup?[].concat(toConsumableArray(document.querySelectorAll('img[data-vue-img-group="'+i.dataset.vueImgGroup+'"]'))):[i],e.set(o,"images",t.map(function(e){return e.dataset.vueImgSrc})),e.set(o,"titles",t.map(function(e){return e.dataset.vueImgTitle})),e.set(o,"sourceButtons",t.map(function(e){return"true"===e.dataset.vueImgSourceButton})),e.set(o,"currentImageIndex",t.indexOf(i)),e.set(o,"handlers",r.events),e.set(o,"closed",!1)})}})};"undefined"!=typeof window&&window.Vue&&window.Vue.use(v_img_install);/* harmony default export */ var v_img = (v_img_install);
//# sourceMappingURL=v-img.mjs.map

// EXTERNAL MODULE: ./node_modules/ks-vue-scrollmagic/dist/ks-vue-scrollmagic.js
var ks_vue_scrollmagic = __webpack_require__("gr9R");
var ks_vue_scrollmagic_default = /*#__PURE__*/__webpack_require__.n(ks_vue_scrollmagic);

// EXTERNAL MODULE: ./node_modules/vue-masonry-css/dist/vue-masonry.es2015.js
var vue_masonry_es2015 = __webpack_require__("G7ha");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var object_keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(object_keys);

// EXTERNAL MODULE: ./node_modules/b_/index.js
var b_ = __webpack_require__("j99E");
var b__default = /*#__PURE__*/__webpack_require__.n(b_);

// CONCATENATED MODULE: ./src/v-bem.js




var elementKey = void 0;

/* harmony default export */ var v_bem = ({
  install: function install(Vue) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var b = Object(b_["B"])(config);
    var blockPrefix = config.blockPrefix !== void 0 ? config.blockPrefix : '';
    elementKey = config.elementKey !== void 0 ? config.elementKey : '__';
    var classSeparator = config.classSeparator !== void 0 ? config.classSeparator : ' ';
    var directiveName = config.directiveName !== void 0 ? config.directiveName : 'bem';
    Vue.directive(directiveName, function (dom, binding, vNode) {
      var block = blockPrefix + vNode.context.$options._componentTag;
      var element = detectElement(binding, vNode.context);
      var mods = correctMods(binding.value);

      var oldClasses = dom.vBem === void 0 ? [] : dom.vBem.split(classSeparator);
      var classes = b(block, element, mods);

      oldClasses.forEach(function (className) {
        return dom.classList.remove(className);
      });
      classes.split(classSeparator).forEach(function (className) {
        return dom.classList.add(className);
      });
      dom.vBem = classes;
    });
  }
});

function correctMods() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var mods = value;
  if (typeof value === 'string') {
    mods = {};
    mods[value] = true;
  }
  if (mods[elementKey] !== void 0) {
    delete mods[elementKey];
  }
  return mods;
}

function detectElement(binding, context) {
  var element = void 0;
  var modifiers = keys_default()(binding.modifiers);
  if (binding.arg !== void 0) {
    element = context[binding.arg];
  } else if (modifiers.length === 1) {
    element = modifiers[0];
  } else if (binding.value !== void 0 && typeof_default()(binding.value) === 'object' && binding.value[elementKey] !== void 0) {
    element = binding.value[elementKey];
  }
  return element;
}
// EXTERNAL MODULE: ./node_modules/vue-bg-src/dist/vue-bg-src.es2015.js
var vue_bg_src_es2015 = __webpack_require__("NBEb");

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








var mediaQueries = {
  ss: '(min-width: 576px)',
  ms: '(min-width: 768px)',
  ls: '(min-width: 992px)',
  xs: '(min-width: 1400px)'
};
vue_esm["a" /* default */].use(vue_bg_src_es2015["a" /* default */], { mediaQueries: mediaQueries });
vue_esm["a" /* default */].use(vue_masonry_es2015["a" /* default */]);
vue_esm["a" /* default */].use(v_bem, {});

__webpack_require__("uMhA");

vue_esm["a" /* default */].use(v_img);
vue_esm["a" /* default */].use(ks_vue_scrollmagic_default.a);

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "OB9c":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/38-l.ce4f48c.jpg";

/***/ }),

/***/ "OlgI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/01-m.0336877.jpg";

/***/ }),

/***/ "OnGx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/04-s.d8c5e51.jpg";

/***/ }),

/***/ "PVdI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/33-s.39cddff.jpg";

/***/ }),

/***/ "QSvC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/31-s.321dd77.jpg";

/***/ }),

/***/ "RE5C":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/25-m.01cc97e.jpg";

/***/ }),

/***/ "RbU2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/35-l.32fd47d.jpg";

/***/ }),

/***/ "RqZL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/28-l.226c0a7.jpg";

/***/ }),

/***/ "RvJQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/32-l.736cf6a.jpg";

/***/ }),

/***/ "S3ov":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./01-s.jpg": "D37o",
	"./02-s.jpg": "77VX",
	"./03-s.jpg": "/q6K",
	"./04-s.jpg": "OnGx",
	"./05-s.jpg": "szEJ",
	"./06-s.jpg": "8S2b",
	"./07-s.jpg": "kiTz",
	"./08-s.jpg": "Dl04",
	"./09-s.jpg": "rsN+",
	"./10-s.jpg": "+fdp",
	"./11-s.jpg": "lns+",
	"./12-s.jpg": "1zbC",
	"./13-s.jpg": "gqAm",
	"./14-s.jpg": "fU0H",
	"./15-s.jpg": "5bsd",
	"./16-s.jpg": "4R1l",
	"./17-s.jpg": "cKO2",
	"./18-s.jpg": "VUX9",
	"./19-s.jpg": "MqRX",
	"./20-s.jpg": "Vgsb",
	"./21-s.jpg": "kHLG",
	"./22-s.jpg": "kINZ",
	"./23-s.jpg": "7QxK",
	"./24-s.jpg": "fwNT",
	"./25-s.jpg": "f4Qe",
	"./26-s.jpg": "Ua1b",
	"./27-s.jpg": "Hufu",
	"./28-s.jpg": "of0P",
	"./29-s.jpg": "adRU",
	"./30-s.jpg": "v3ig",
	"./31-s.jpg": "QSvC",
	"./32-s.jpg": "e7/v",
	"./33-s.jpg": "PVdI",
	"./34-s.jpg": "TcmZ",
	"./35-s.jpg": "y+t4",
	"./36-s.jpg": "c4yY",
	"./37-s.jpg": "6JWZ",
	"./38-s.jpg": "hyb8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "S3ov";

/***/ }),

/***/ "SAKm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/38-m.005bd3c.jpg";

/***/ }),

/***/ "SF5G":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/perinatal-putin-m.e36e207.jpg";

/***/ }),

/***/ "SgGY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/37-m.6c8a0db.jpg";

/***/ }),

/***/ "T8ql":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/internet-m.391182c.jpg";

/***/ }),

/***/ "TKxS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/27-l.20840eb.jpg";

/***/ }),

/***/ "TcmZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/34-s.a236418.jpg";

/***/ }),

/***/ "Ua1b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/26-s.77ebe9d.jpg";

/***/ }),

/***/ "Udk2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/29-l.53f9fa0.jpg";

/***/ }),

/***/ "VUX9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/18-s.9f9ff72.jpg";

/***/ }),

/***/ "Vgsb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/20-s.aa68303.jpg";

/***/ }),

/***/ "WoOq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/36-m.ae74908.jpg";

/***/ }),

/***/ "XBNR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/20-m.1332cb7.jpg";

/***/ }),

/***/ "Xx8z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xz/J":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/bridge-m.ffd2064.jpg";

/***/ }),

/***/ "YyD8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/35-m.df8a0ef.jpg";

/***/ }),

/***/ "a7Of":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/15-m.3327a41.jpg";

/***/ }),

/***/ "aQqe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/03-m.f02bfdd.jpg";

/***/ }),

/***/ "aZbR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/20-l.1311fc4.jpg";

/***/ }),

/***/ "adRU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/29-s.1f04b1a.jpg";

/***/ }),

/***/ "asa4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/31-m.ae0a39f.jpg";

/***/ }),

/***/ "atN/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/road-s.966cba5.jpg";

/***/ }),

/***/ "c4yY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/36-s.14d4bc6.jpg";

/***/ }),

/***/ "cKO2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/17-s.1b38231.jpg";

/***/ }),

/***/ "cfsg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/17-l.079b772.jpg";

/***/ }),

/***/ "d2v8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/13-m.2db126d.jpg";

/***/ }),

/***/ "dR3f":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/12-l.9172527.jpg";

/***/ }),

/***/ "dwy0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/31-l.e7cfec3.jpg";

/***/ }),

/***/ "e5uJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/road-x.e47157e.jpg";

/***/ }),

/***/ "e7/v":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/32-s.6856e19.jpg";

/***/ }),

/***/ "eOcC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/18-m.2143ffc.jpg";

/***/ }),

/***/ "ez7F":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/33-l.aaba501.jpg";

/***/ }),

/***/ "f4Qe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/25-s.5b7172c.jpg";

/***/ }),

/***/ "fO3U":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/14-m.491d7c1.jpg";

/***/ }),

/***/ "fU0H":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/14-s.4bba363.jpg";

/***/ }),

/***/ "flvd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/34-m.584c9d1.jpg";

/***/ }),

/***/ "ftnl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/standart.ea3b86f.svg";

/***/ }),

/***/ "fwNT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/24-s.b7fc2aa.jpg";

/***/ }),

/***/ "gqAm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/13-s.0d458e8.jpg";

/***/ }),

/***/ "h+hI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/25-l.6d388ce.jpg";

/***/ }),

/***/ "h8gT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/22-l.7cb1885.jpg";

/***/ }),

/***/ "hyb8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/38-s.72972eb.jpg";

/***/ }),

/***/ "jGeF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/08-m.7788e1d.jpg";

/***/ }),

/***/ "jWbr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/01-l.d4d3a6f.jpg";

/***/ }),

/***/ "kHLG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/21-s.ec4a337.jpg";

/***/ }),

/***/ "kINZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/22-s.f182e31.jpg";

/***/ }),

/***/ "kew0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/22-m.89d0b7c.jpg";

/***/ }),

/***/ "kiTz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/07-s.80a827a.jpg";

/***/ }),

/***/ "ll0C":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/10-l.2f01e1f.jpg";

/***/ }),

/***/ "lns+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/11-s.1a27a00.jpg";

/***/ }),

/***/ "ltP/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/15-l.455986a.jpg";

/***/ }),

/***/ "muMd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/17-m.76efea8.jpg";

/***/ }),

/***/ "muVv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/07-l.1be7a2a.jpg";

/***/ }),

/***/ "nMmY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/24-m.450442a.jpg";

/***/ }),

/***/ "of0P":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/28-s.649ad6d.jpg";

/***/ }),

/***/ "psHA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/05-m.982d9d2.jpg";

/***/ }),

/***/ "qHo6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/28-m.3c4b521.jpg";

/***/ }),

/***/ "qMvQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/18-l.9cdfe91.jpg";

/***/ }),

/***/ "rsN+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/09-s.39e41b0.jpg";

/***/ }),

/***/ "s3EE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/14-l.436c699.jpg";

/***/ }),

/***/ "szEJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/05-s.4173613.jpg";

/***/ }),

/***/ "t0v+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/21-l.22fec6e.jpg";

/***/ }),

/***/ "tCG1":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "tIRK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/road-m.01b8a83.jpg";

/***/ }),

/***/ "u7iv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/12-m.c549da6.jpg";

/***/ }),

/***/ "uMhA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v+Dy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/04-l.65ab851.jpg";

/***/ }),

/***/ "v3ig":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/30-s.d378da0.jpg";

/***/ }),

/***/ "v4Yc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/perinatal-m.2e7d0e6.jpg";

/***/ }),

/***/ "wP7n":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/27-m.fccb31c.jpg";

/***/ }),

/***/ "woGB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/30-l.ea25a48.jpg";

/***/ }),

/***/ "xsgK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/lopazna-m.aee6b59.jpg";

/***/ }),

/***/ "y+t4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/35-s.03c99c4.jpg";

/***/ }),

/***/ "ySjQ":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./01-l.jpg": "jWbr",
	"./02-l.jpg": "34B5",
	"./03-l.jpg": "Ifd5",
	"./04-l.jpg": "v+Dy",
	"./05-l.jpg": "Ke2r",
	"./06-l.jpg": "FCp/",
	"./07-l.jpg": "muVv",
	"./08-l.jpg": "N10u",
	"./09-l.jpg": "G38D",
	"./10-l.jpg": "ll0C",
	"./11-l.jpg": "HnSn",
	"./12-l.jpg": "dR3f",
	"./13-l.jpg": "2/31",
	"./14-l.jpg": "s3EE",
	"./15-l.jpg": "ltP/",
	"./16-l.jpg": "7elO",
	"./17-l.jpg": "cfsg",
	"./18-l.jpg": "qMvQ",
	"./19-l.jpg": "H4T9",
	"./20-l.jpg": "aZbR",
	"./21-l.jpg": "t0v+",
	"./22-l.jpg": "h8gT",
	"./23-l.jpg": "HrYy",
	"./24-l.jpg": "/q2J",
	"./25-l.jpg": "h+hI",
	"./26-l.jpg": "MXh8",
	"./27-l.jpg": "TKxS",
	"./28-l.jpg": "RqZL",
	"./29-l.jpg": "Udk2",
	"./30-l.jpg": "woGB",
	"./31-l.jpg": "dwy0",
	"./32-l.jpg": "RvJQ",
	"./33-l.jpg": "ez7F",
	"./34-l.jpg": "8rCB",
	"./35-l.jpg": "RbU2",
	"./36-l.jpg": "5kNS",
	"./37-l.jpg": "Iw74",
	"./38-l.jpg": "OB9c"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ySjQ";

/***/ }),

/***/ "yyfU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/schoolbus-m.05b27fc.jpg";

/***/ }),

/***/ "zS2w":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "zosO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/16-m.463b184.jpg";

/***/ }),

/***/ "zqXa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/32-m.87433c4.jpg";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// assets/js/app.ee73997bb37a6e1b434a.js